/* REDLINE — comportamenti del tema */
(function () {
  'use strict';

  /* --- menu mobile ------------------------------------------------------- */
  var menuBtn = document.querySelector('[data-menu]');
  var nav = document.querySelector('[data-nav]');
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', function () {
      var aperto = nav.classList.toggle('aperto');
      menuBtn.setAttribute('aria-expanded', aperto ? 'true' : 'false');
    });
  }

  // Su telefono la scelta lingua sta dentro al menu: in testata toglieva
  // spazio al logo. Sopra i 640 px torna al suo posto.
  (function lingueNelMenu() {
    var lingue = document.querySelector('.lingue');
    if (!lingue || !nav) return;
    var azioni = lingue.parentNode;
    var stretto = window.matchMedia('(max-width: 640px)');
    function sistema() {
      if (stretto.matches) {
        if (lingue.parentNode !== nav) nav.appendChild(lingue);
      } else if (lingue.parentNode !== azioni) {
        azioni.insertBefore(lingue, azioni.firstChild);
      }
    }
    sistema();
    (stretto.addEventListener ? stretto.addEventListener.bind(stretto, 'change')
                              : stretto.addListener.bind(stretto))(sistema);
  })();

  /* --- testata che si riduce allo scroll ---------------------------------- */
  var testata = document.querySelector('[data-testata]') || document.querySelector('.testata');
  if (testata) {
    var ridotta = false;
    var suScroll = function () {
      var giu = window.scrollY > 90;
      if (giu !== ridotta) { ridotta = giu; testata.classList.toggle('testata--ridotta', giu); }
    };
    window.addEventListener('scroll', suScroll, { passive: true });
    suScroll();
  }


  /* --- aggiunta al carrello via AJAX ------------------------------------- */
  function testo(chiave, fallback) {
    var d = (window.RL_I18N || {})[window.RL_LANG || 'it'];  /* ripiego se assente */
    return d && d.ui[chiave] ? d.ui[chiave] : fallback;
  }

  function aggiornaConteggio() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js',
                 { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('.carrello b').forEach(function (b) { b.textContent = c.item_count; });
      })
      .catch(function () {});
  }

  function conferma(btn, ok) {
    var originale = btn.dataset.testoOriginale || btn.textContent.trim();
    btn.dataset.testoOriginale = originale;
    btn.textContent = ok ? testo('btn.aggiunto', 'Aggiunto \u2713')
                         : testo('carrello.errore', 'Errore');
    btn.disabled = true;
    setTimeout(function () {
      btn.textContent = originale;
      btn.disabled = false;
    }, 1600);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.modulo-carrello');
    if (!form) return;
    // "Compra ora" deve andare al pagamento: lascio passare l'invio normale,
    // che porta con sé taglia, quantità e return_to=/checkout
    if (e.submitter && e.submitter.hasAttribute('data-compra-ora')) return;
    e.preventDefault();

    var btn = e.submitter || form.querySelector('button[type=submit]');
    var dati = new FormData(form);
    // il campo id deve esserci sempre: senza, Shopify non sa quale variante aggiungere
    if (!dati.get('id')) { form.submit(); return; }
    if (!dati.get('quantity')) dati.set('quantity', 1);

    if (btn) { btn.disabled = true; }

    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: dati })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, corpo: j }; }); })
      .then(function (res) {
        if (btn) btn.disabled = false;
        if (!res.ok) {
          if (btn) conferma(btn, false);
          if (res.corpo && res.corpo.description) console.warn('Carrello:', res.corpo.description);
          return;
        }
        if (btn) conferma(btn, true);
        return aggiornaConteggio();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; conferma(btn, false); }
        form.submit();   // ripiego: invio normale del modulo
      });
  });

  /* --- miniature della pagina prodotto ------------------------------------ */
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-miniatura]');
    if (!m) return;
    var grande = document.getElementById('mediaPrincipale');
    if (grande && m.getAttribute('data-grande')) grande.src = m.getAttribute('data-grande');
  });

  /* --- timer restock ------------------------------------------------------ */
  // Conta verso un istante assoluto: ogni secondo ricalcola la differenza
  // dall'orologio reale, quindi non accumula ritardi e non riparte al ricaricare.
  document.querySelectorAll('[data-timer]').forEach(function (box) {
    var fine = new Date(box.getAttribute('data-fine')).getTime();
    if (isNaN(fine)) return;
    var q = function (sel) { return box.querySelector(sel); };
    var due = function (n) { return n < 10 ? '0' + n : String(n); };
    var giro;

    // data mostrata nel formato della lingua scelta, sull'ora locale del visitatore
    function scriviData() {
      var el = q('[data-timer-data]');
      if (!el) return;
      var lang = { it: 'it-IT', en: 'en-GB', de: 'de-DE', fr: 'fr-FR' }[window.RL_LANG || 'it'] || 'it-IT';
      try {
        el.textContent = new Date(fine).toLocaleString(lang,
          { weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' });
      } catch (e) {}
    }

    function aggiorna() {
      var resto = fine - Date.now();
      if (resto <= 0) {
        clearInterval(giro);
        if (box.getAttribute('data-nascondi') === 'true') { box.hidden = true; return; }
        q('[data-timer-conto]').hidden = true;
        q('[data-timer-titolo]').hidden = true;
        q('[data-timer-finito]').hidden = false;
        box.classList.add('restock--finito');
        return;
      }
      var s = Math.floor(resto / 1000);
      q('[data-timer-giorni]').textContent = due(Math.floor(s / 86400));
      q('[data-timer-ore]').textContent = due(Math.floor(s % 86400 / 3600));
      q('[data-timer-minuti]').textContent = due(Math.floor(s % 3600 / 60));
      q('[data-timer-secondi]').textContent = due(s % 60);
    }

    scriviData();
    document.addEventListener('rl:lingua', scriviData);
    aggiorna();
    giro = setInterval(aggiorna, 1000);
    // tornando sulla scheda dopo ore, si riallinea subito
    document.addEventListener('visibilitychange', aggiorna);
  });

  /* --- filtri catalogo --------------------------------------------------- */
  var griglia = document.querySelector('[data-griglia]');
  if (!griglia) return;

  var schede = Array.prototype.slice.call(griglia.querySelectorAll('[data-scheda]'));
  var contatore = document.querySelector('[data-conteggio]');
  var vuoto = griglia.querySelector('[data-vuoto]');
  var stato = { set: '', cat: '', lang: '', q: '' };

  function gruppo(chiave) {
    // i porti della rotta sono link (<a>), i filtri sono pulsanti: servono entrambi
    return Array.prototype.slice.call(document.querySelectorAll('[data-' + chiave + ']'))
      .filter(function (el) { return el.tagName === 'BUTTON' || el.tagName === 'A'; });
  }

  // indice testuale per la ricerca: va rifatto quando cambia la lingua,
  // altrimenti si cerca nel testo della lingua precedente
  function indicizza() {
    schede.forEach(function (s) {
      s.dataset.testo = (s.textContent || '').toLowerCase().replace(/\s+/g, ' ');
    });
  }
  indicizza();

  function aggiornaPlaceholder() {
    var c = document.querySelector('[data-cerca]');
    var d = (window.RL_I18N || {})[window.RL_LANG || 'it'];  /* ripiego se assente */
    if (c && d && d.ui['cerca.placeholder']) c.placeholder = d.ui['cerca.placeholder'];
  }

  var passo = parseInt(griglia.getAttribute('data-passo') || '0', 10);
  var mostrati = passo || Infinity;
  var pulsanteAltri = document.querySelector('[data-altri]');

  function applica() {
    var visibili = 0;
    schede.forEach(function (s) {
      var ok =
        (!stato.set || s.dataset.set === stato.set) &&
        (!stato.cat || s.dataset.cat === stato.cat) &&
        (!stato.lang || s.dataset.lang === stato.lang) &&
        (!stato.q || (s.dataset.testo || '').indexOf(stato.q) > -1);
      if (ok) visibili++;
      s.hidden = !ok || visibili > mostrati;
    });
    if (contatore) {
      var d = (window.RL_I18N || {})[window.RL_LANG || 'it'];  /* ripiego se assente */
      var uno = d ? d.ui['conta.uno'] : 'prodotto';
      var molti = d ? d.ui['conta.molti'] : 'prodotti';
      contatore.textContent = visibili + ' ' + (visibili === 1 ? uno : molti);
    }
    if (vuoto) vuoto.hidden = visibili !== 0;
    if (pulsanteAltri) pulsanteAltri.hidden = visibili <= mostrati;
  }

  function sincronizza(chiave) {
    gruppo(chiave).forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset[chiave] === stato[chiave] ? 'true' : 'false');
    });
    var sel = document.querySelector('select[data-filtro="' + chiave + '"]');
    if (sel && sel.value !== stato[chiave]) sel.value = stato[chiave];
  }

  function impostaFiltro(chiave, valore, scorri) {
    stato[chiave] = valore || '';
    mostrati = passo || Infinity;
    sincronizza(chiave);
    applica();
    if (scorri) {
      var cat = document.getElementById('catalogo');
      if (cat) cat.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // pulsanti (usati ancora dal navigatore dei set)
  ['set', 'cat', 'lang'].forEach(function (chiave) {
    gruppo(chiave).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (btn.tagName === 'A') e.preventDefault();   // il catalogo e' gia' in pagina
        var valore = btn.dataset[chiave];
        if (stato[chiave] === valore && valore !== '') valore = '';
        impostaFiltro(chiave, valore, chiave === 'set' && !!valore);
      });
    });
  });

  // menù a tendina del catalogo
  document.querySelectorAll('select[data-filtro]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      impostaFiltro(sel.getAttribute('data-filtro'), sel.value, false);
    });
  });

  // pannelli della vetrina: portano al catalogo filtrato per categoria
  document.addEventListener('click', function (e) {
    var v = e.target.closest('[data-vai-cat]');
    if (!v || !griglia) return;          // senza catalogo in pagina si segue il link
    e.preventDefault();
    impostaFiltro('cat', v.getAttribute('data-vai-cat'), true);
  });

  if (pulsanteAltri) {
    pulsanteAltri.addEventListener('click', function () {
      mostrati += passo || 16;
      applica();
    });
  }

  var campo = document.querySelector('[data-cerca]');
  var pulisci = document.querySelector('[data-pulisci]');
  if (campo) {
    var attesa;
    campo.addEventListener('input', function () {
      clearTimeout(attesa);
      attesa = setTimeout(function () {
        stato.q = campo.value.trim().toLowerCase();
        applica();
      }, 150);
    });
    campo.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { campo.value = ''; stato.q = ''; applica(); }
    });
  }
  if (pulisci) {
    pulisci.addEventListener('click', function () {
      if (campo) campo.value = '';
      stato.q = '';
      applica();
    });
  }

  var campoTestata = document.querySelector('[data-cerca-testata]');
  if (campoTestata && campo) {
    campoTestata.addEventListener('input', function () {
      campo.value = campoTestata.value;
      stato.q = campoTestata.value.trim().toLowerCase();
      applica();
    });
  }

  var azzera = document.querySelector('[data-azzera]');
  if (azzera) {
    azzera.addEventListener('click', function () {
      ['set', 'cat', 'lang'].forEach(function (k) { stato[k] = ''; sincronizza(k); });
      stato.q = '';
      if (campo) campo.value = '';
      applica();
    });
  }

  // Filtri iniziali presi dall'indirizzo: /pages/catalogo?cat=case&set=OP-17&q=zoro
  // Attenzione: "lang" è già usato per la lingua del sito (?lang=de), quindi la
  // lingua del prodotto si passa con "lingua" (?lingua=jap). Se usassimo lo stesso
  // nome, chi arriva con ?lang=de si troverebbe il catalogo vuoto.
  (function daIndirizzo() {
    var par = new URLSearchParams(location.search);
    [['set', 'set'], ['cat', 'cat'], ['lingua', 'lang']].forEach(function (coppia) {
      var v = par.get(coppia[0]);
      if (!v) return;
      stato[coppia[1]] = coppia[0] === 'set'
        ? v.toLowerCase().replace(/-/g, '')
        : v.toLowerCase();
      sincronizza(coppia[1]);
    });
    var q = par.get('q');
    if (q && campo) { campo.value = q; stato.q = q.toLowerCase(); }
  })();

  aggiornaPlaceholder();
  applica();

  document.addEventListener('rl:lingua', function () {
    indicizza();
    aggiornaPlaceholder();
    applica();
  });


  /* --- finestra dettaglio prodotto ---------------------------------------- */
  var modale = document.createElement('div');
  modale.className = 'modale';
  modale.setAttribute('role', 'dialog');
  modale.setAttribute('aria-modal', 'true');
  modale.hidden = true;
  modale.innerHTML =
    '<div class="modale__pannello">' +
      '<button class="modale__chiudi" type="button" data-chiudi aria-label="Chiudi">\u2715</button>' +
      '<div class="modale__griglia">' +
        '<div class="modale__media" data-m-media></div>' +
        '<div class="modale__corpo">' +
          '<span class="scheda__set" data-m-set></span>' +
          '<h2 data-m-titolo></h2>' +
          '<div class="modale__prezzo"><span class="prezzo" data-m-prezzo></span><s class="prezzo__pieno" data-m-pieno></s></div>' +
          '<p class="modale__testo" data-m-testo></p>' +
          '<div class="specs" data-m-specs></div>' +
          '<div class="modale__azioni" data-m-azioni></div>' +
        '</div>' +
      '</div>' +
    '</div>';
  document.body.appendChild(modale);

  function apriModale(scheda) {
    var media = scheda.querySelector('.scheda__media');
    var img = media ? media.querySelector('img') : null;
    var box = modale.querySelector('[data-m-media]');
    box.className = 'modale__media' + (media && media.classList.contains('scheda__media--bianco') ? ' modale__media--bianco' : '');
    box.innerHTML = img ? '<img src="' + img.getAttribute('src') + '" alt="' + (img.getAttribute('alt') || '') + '">' : '';

    var set = scheda.querySelector('.scheda__set');
    var titolo = scheda.querySelector('h3');
    var prezzo = scheda.querySelector('.prezzo');
    var pieno = scheda.querySelector('.prezzo__pieno');
    var piena = scheda.querySelector('.scheda__desc-piena');
    var breve = scheda.querySelector('.scheda__desc');

    modale.querySelector('[data-m-set]').textContent = set ? set.textContent.trim() : '';
    modale.querySelector('[data-m-titolo]').textContent = titolo ? titolo.textContent.trim() : '';
    modale.querySelector('[data-m-prezzo]').innerHTML = prezzo ? prezzo.innerHTML : '';
    var elPieno = modale.querySelector('[data-m-pieno]');
    elPieno.textContent = pieno ? pieno.textContent : '';
    elPieno.hidden = !pieno;
    modale.querySelector('[data-m-testo]').textContent =
      (piena && piena.textContent.trim()) || (breve ? breve.textContent.trim() : '');

    var specs = scheda.querySelector('.specs');
    modale.querySelector('[data-m-specs]').innerHTML = specs ? specs.innerHTML : '';

    var azioni = scheda.querySelector('.scheda__azioni');
    var dest = modale.querySelector('[data-m-azioni]');
    dest.innerHTML = '';
    if (azioni) {
      Array.prototype.forEach.call(azioni.children, function (n) {
        dest.appendChild(n.cloneNode(true));
      });
    }

    modale.hidden = false;
    modale.classList.add('aperta');
    document.body.classList.add('bloccato');
    var chiudi = modale.querySelector('[data-chiudi]');
    if (chiudi) chiudi.focus();
  }

  function chiudiModale() {
    modale.classList.remove('aperta');
    modale.hidden = true;
    document.body.classList.remove('bloccato');
  }

  modale.addEventListener('click', function (e) {
    if (e.target === modale || e.target.closest('[data-chiudi]')) chiudiModale();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modale.hidden) chiudiModale();
  });

  // nel catalogo dimostrativo i prodotti non esistono ancora su Shopify:
  // il clic apre la finestra invece di portare a una pagina inesistente
  griglia.addEventListener('click', function (e) {
    var apri = e.target.closest('[data-apri]');
    var scheda = e.target.closest('[data-scheda]');
    if (!scheda) return;
    if (apri && griglia.hasAttribute('data-demo')) {
      e.preventDefault();
      apriModale(scheda);
      return;
    }
    var acq = e.target.closest('[data-acquista]');
    if (acq && griglia.hasAttribute('data-demo')) {
      e.preventDefault();
      apriModale(scheda);
    }
  });

  /* --- catalogo dimostrativo: pulsante finto, nessun carrello reale ------- */
  /* Attenzione: qui NON usare una variabile chiamata 'testo', coprirebbe la
     funzione testo() definita sopra e la renderebbe inutilizzabile. */
  griglia.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-aggiungi]');
    if (!btn) return;                 // i prodotti veri usano un <form>, non questo pulsante
    if (griglia.hasAttribute('data-demo')) {
      console.info(testo('carrello.demo', 'Catalogo dimostrativo: collega una collezione per vendere davvero'));
    }
    var badge = document.querySelector('.carrello b');
    if (badge) badge.textContent = parseInt(badge.textContent || '0', 10) + 1;
    var etichetta = btn.textContent;
    btn.textContent = testo('btn.aggiunto', 'Aggiunto \u2713');
    setTimeout(function () { btn.textContent = etichetta; }, 1400);
  });

})();
